import { Ao3SiteProvider } from "@/hooks/ao3SiteContext";
import Ao3Header from "./components/Ao3Header";
import Ao3Hero from "./components/Ao3Hero";
import Ao3Stats from "./components/Ao3Stats";
import Ao3Features from "./components/Ao3Features";
import Ao3Screenshots from "./components/Ao3Screenshots";
import Ao3Platforms from "./components/Ao3Platforms";
import Ao3Keywords from "./components/Ao3Keywords";
import Ao3Faq from "./components/Ao3Faq";
import Ao3Cta from "./components/Ao3Cta";
import Ao3Footer from "./components/Ao3Footer";
import Ao3DownloadModal from "./components/Ao3DownloadModal";
import Ao3ReportButton from "./components/Ao3ReportButton";

export default function Home() {
  return (
    <Ao3SiteProvider>
      <div className="min-h-screen w-full bg-background-50">
        <Ao3Header />
        <main className="w-full">
          <Ao3Hero />
          <Ao3Stats />
          <Ao3Features />
          <Ao3Screenshots />
          <Ao3Platforms />
          <Ao3Keywords />
          <Ao3Faq />
          <Ao3Cta />
        </main>
        <Ao3Footer />
        <Ao3DownloadModal />
        <Ao3ReportButton />
      </div>
    </Ao3SiteProvider>
  );
}